import {
  COLOR_CODES_TOOL,
  COLOR_PALETTE_TOOL,
  COLOR_PICKER_TOOL,
  COLOR_PALETTE_FROM_IMAGE,
  COLOR_WHEEL_TOOL,
  FONT_GENERATOR_TOOL,
  EMOJIS_TOOL,
  SYMBOLS_TOOL,
  MP4_MP3_TOOL,
  MOV_TO_MP4_TOOL,
  MKV_TO_MP4_TOOL,
  WEBM_TO_MP4_TOOL,
  CROP_VIDEO_TOOL,
  TRIM_VIDEO_TOOL,
  MERGE_PDF_TOOL,
  SPLIT_PDF_TOOL,
  COMPRESS_PDF_TOOL,
  JPG_TO_PNG_TOOL,
  PNG_TO_JPG_TOOL,
  HEIC_TO_JPG_TOOL,
  PNG_TO_SVG_TOOL,
  PDF_TO_JPG_TOOL,
  WORD_TO_PDF_TOOL,
  PDF_TO_WORD_TOOL,
  PNG_TO_PDF_TOOL,
  JPG_TO_PDF_TOOL,
  EXCEL_TO_PDF_TOOL,
  PPT_TO_PDF_TOOL,
  COMPRESS_IMAGE_TOOL,
  RESIZE_IMAGE_TOOL,
  SHARPEN_IMAGE,
  PHOTO_CAPTION,
  SVG_TO_PNG_TOOL,
} from './tools';

export const imageSwitcherData = [
  {
    text: 'Compress',
    value: COMPRESS_IMAGE_TOOL.id,
    url: COMPRESS_IMAGE_TOOL.href,
    tooltip: 'Compress your image size',
  },
  {
    text: 'Resize',
    value: RESIZE_IMAGE_TOOL.id,
    url: RESIZE_IMAGE_TOOL.href,
    tooltip: 'Resize your image size',
  },
  {
    text: 'Sharpen',
    value: SHARPEN_IMAGE.id,
    url: SHARPEN_IMAGE.href,
    tooltip: 'Sharpen your image',
  },
  {
    text: 'Caption',
    value: PHOTO_CAPTION.id,
    url: PHOTO_CAPTION.href,
    tooltip: 'Add a caption to your image',
  },
];

export const toPdfSwitcherData = [
  {
    text: 'JPG',
    value: JPG_TO_PDF_TOOL.id,
    url: JPG_TO_PDF_TOOL.href,
    tooltip: 'Convert JPG to PDF',
  },
  {
    text: 'PNG',
    value: PNG_TO_PDF_TOOL.id,
    url: PNG_TO_PDF_TOOL.href,
    tooltip: 'Convert PNG to PDF',
  },
  {
    text: 'Word',
    value: WORD_TO_PDF_TOOL.id,
    url: WORD_TO_PDF_TOOL.href,
    tooltip: 'Convert Word to PDF',
  },
  {
    text: 'Excel',
    value: EXCEL_TO_PDF_TOOL.id,
    url: EXCEL_TO_PDF_TOOL.href,
    tooltip: 'Convert Excel to PDF',
  },
  {
    text: 'PPT',
    value: PPT_TO_PDF_TOOL.id,
    url: PPT_TO_PDF_TOOL.href,
    tooltip: 'Convert PPT to PDF',
  },
];

export const pdfToSwitcherData = [
  {
    text: 'JPG',
    value: PDF_TO_JPG_TOOL.id,
    url: PDF_TO_JPG_TOOL.href,
    tooltip: 'Convert PDF to JPG',
  },
  {
    text: 'Word',
    value: PDF_TO_WORD_TOOL.id,
    url: PDF_TO_WORD_TOOL.href,
    tooltip: 'Convert PDF to Word',
  },
];

export const converterSwitcherData = [
  {
    text: 'JPG to PNG',
    value: JPG_TO_PNG_TOOL.id,
    url: JPG_TO_PNG_TOOL.href,
    tooltip: 'Convert JPG to PNG',
  },
  {
    text: 'PNG to JPG',
    value: PNG_TO_JPG_TOOL.id,
    url: PNG_TO_JPG_TOOL.href,
    tooltip: 'Convert PNG to JPG',
  },
  {
    text: 'HEIC to JPG',
    value: HEIC_TO_JPG_TOOL.id,
    url: HEIC_TO_JPG_TOOL.href,
    tooltip: 'Convert HEIC to JPG',
  },
  {
    text: 'PNG to SVG',
    value: PNG_TO_SVG_TOOL.id,
    url: PNG_TO_SVG_TOOL.href,
    tooltip: 'Convert PNG to SVG',
  },
  {
    text: 'SVG to PNG',
    value: SVG_TO_PNG_TOOL.id,
    url: SVG_TO_PNG_TOOL.href,
    tooltip: 'Convert SVG to PNG',
  },
];

export const colorSwitcherData = [
  {
    text: 'Picker',
    value: COLOR_PICKER_TOOL.id,
    url: COLOR_PICKER_TOOL.href,
    tooltip: 'Color picker',
  },
  {
    text: 'Wheel',
    value: COLOR_WHEEL_TOOL.id,
    url: COLOR_WHEEL_TOOL.href,
    tooltip: 'Color wheel',
  },
  {
    text: 'Converter',
    value: COLOR_CODES_TOOL.id,
    url: COLOR_CODES_TOOL.href,
    tooltip: 'Color converter',
  },
  {
    text: 'Palette',
    value: COLOR_PALETTE_TOOL.id,
    url: COLOR_PALETTE_TOOL.href,
    tooltip: 'Color palette',
  },
  {
    text: 'Palette from img',
    value: COLOR_PALETTE_FROM_IMAGE.id,
    url: COLOR_PALETTE_FROM_IMAGE.href,
    tooltip: 'Color palette from image',
  },
];

export const pdfSwitcherData = [
  {
    text: 'Merge PDF',
    value: MERGE_PDF_TOOL.id,
    url: MERGE_PDF_TOOL.href,
    tooltip: 'Merge your PDF files',
  },
  {
    text: 'Split PDF',
    value: SPLIT_PDF_TOOL.id,
    url: SPLIT_PDF_TOOL.href,
    tooltip: 'Split your PDF pages',
  },
  {
    text: 'Compress PDF',
    value: COMPRESS_PDF_TOOL.id,
    url: COMPRESS_PDF_TOOL.href,
    tooltip: 'Compress your PDF size',
  },
];

export const videoSwitcherData = [
  {
    text: 'MOV',
    value: MOV_TO_MP4_TOOL.id,
    url: MOV_TO_MP4_TOOL.href,
    tooltip: 'Convert MOV to MP4',
  },
  {
    text: 'MKV',
    value: MKV_TO_MP4_TOOL.id,
    url: MKV_TO_MP4_TOOL.href,
    tooltip: 'Convert MKV to MP4',
  },
  {
    text: 'WebM',
    value: WEBM_TO_MP4_TOOL.id,
    url: WEBM_TO_MP4_TOOL.href,
    tooltip: 'Convert WebM to MP4',
  },
];

export const videoEditingSwitcherData = [
  {
    text: 'Trim Video',
    value: TRIM_VIDEO_TOOL.id,
    url: TRIM_VIDEO_TOOL.href,
    tooltip: 'Trim your video length',
  },
  {
    text: 'Crop Video',
    value: CROP_VIDEO_TOOL.id,
    url: CROP_VIDEO_TOOL.href,
    tooltip: 'Crop your video size',
  },
  {
    text: 'MP4 to MP3',
    value: MP4_MP3_TOOL.id,
    url: MP4_MP3_TOOL.href,
    tooltip: 'Extract audio',
  },
];

export const textSwitcherData = [
  {
    text: 'Fonts',
    value: FONT_GENERATOR_TOOL.id,
    url: FONT_GENERATOR_TOOL.href,
    tooltip: 'Add a fancy font',
  },
  {
    text: 'Emojis',
    value: EMOJIS_TOOL.id,
    url: EMOJIS_TOOL.href,
    tooltip: 'Add a cool emoji',
  },
  {
    text: 'Symbols',
    value: SYMBOLS_TOOL.id,
    url: SYMBOLS_TOOL.href,
    tooltip: 'Add a funky symbol',
  },
];
